import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Tooltip,
    Typography,
} from "@material-ui/core";

const AlertModal = ({ openModal, handleClose, openDefault, openExternal }) => {
    const openDefaultConnector = () => {
        handleClose();
        openDefault()
    }
    const openExternalConnector = () => {
        handleClose();
        openExternal()
    }
    return (
        <div>
            <Dialog
                open={openModal}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        openModal(false)
                    }
                }}
                // hideBackdrop={true}
                disableEscapeKeyDown={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                id="connector-modal"
            >
                <DialogContent>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Typography>
                                <h5>Set up a Connection</h5>
                                <div className='d-flex justify-content-around mt-3'>
                                    <Tooltip title="Do you have a database?" style={{ fontSize: "1rem" }}>
                                        <button
                                            type='button'
                                            className='mr-4'
                                            onClick={openExternalConnector}
                                            style={{
                                                color: "#000",
                                                background: "transparent",
                                                border: "1px solid grey",
                                                // fontSize: "17px"
                                            }}
                                        >
                                            Setup custom connection</button>
                                    </Tooltip>

                                    <Tooltip title="Have a database created for you" style={{ fontSize: "1rem" }}>
                                        <button
                                            type='button'
                                            className='btn btn-warning text-white ml-4'
                                            onClick={openDefaultConnector}
                                            style={{ fontSize: ".9rem" }}
                                        >
                                            Use default connection
                                        </button>
                                    </Tooltip>
                                </div>
                            </Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button id="button-cancel" onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </div>
    )

}
export default AlertModal